<template>
  <div class="write-comment m-wrapper m-wbox m-container-max bg-layer" v-if="show">
    <div>
      <header>
        <div class="center-wrapper header-box">
          <div>
            <label class="radio" for="radio_nickName">
              <input type="radio" id="radio_nickName" name="myName" v-model="myName" value="nickName"/>
              <div class="mark"></div>
            </label>
            <span :class="{'blue': myName === 'nickName'}">{{$t('lang.contentAnonymous')}}</span>
          </div>
          <div>
            <label class="radio" for="radio_realName">
              <input type="radio" id="radio_realName"  name="myName" v-model="myName" value="realName" />
              <div class="mark"></div>
            </label>
            <span style="flex: 1;text-align: right;" :class="{'blue': myName === 'realName'}">{{$t('lang.contentNamed')}}</span>
          </div>
        </div>
        <div class="right-wrapper header-box">
          <a href="javascript:void(0);"
            :class="{
              'blue': canSend === true,
              'gray': canSend === false
            }"
            @click="send()">{{$t('lang.contentSend')}}</a>
        </div>
      </header>
      <main>
        <div class="relative write-comment-div">
          <transition name="slide-fade">
            <div class="absolute choose-id-box" v-if="isClicked" @click="isClicked = !isClicked">
              <ul>
                <li @click.stop="chooseId(true)">
                  <img src="../assets/images/photo_default_icon.png" alt="" />
                  <a href="javascript:void(0);">{{$t('lang.contentAnonymous')}}</a>
                </li>
                <li @click.stop="chooseId(false)">
                  <img src="../assets/images/photo_default_icon.png" alt=""/>
                  <a href="javascript:void(0);">{{$t('lang.contentNamed')}}</a>
                </li>
              </ul>
            </div>
          </transition>
          <textarea ref="textarea"
          name=""
          cols="30"
          rows="10"
          maxlength="500"
          :placeholder="placeholder"
          style="width: 100%;"
          v-model.trim="content"
          @blur="scrollTo00"></textarea>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { isMideaConnect } from '../utils/utils'
import dataRanger from '../service/data-rangers/index'
export default {
  name: 'ContentComment',
  props: {
    show: {
      require: true,
      default: false
    },
    commentParams: {
      type: Object,
      required: true,
      default: () => {}
    },
    commentType: {
      type: Number,
      required: true,
      default: 1
    }
  },
  data () {
    return {
      content: '',
      isClicked: false,
      targetType: '1',
      nickname: '',
      myName: 'nickName',
      sending: false,
      canSend: false
    }
  },
  computed: {
    placeholder () {
      return this.targetType === '1' ? this.$t('lang.writeComment') : this.$t('lang.writeComment3')
    },
    isMideaConnect () {
      return isMideaConnect()
    },
    hasType () {
      return this.$route.query.type === 'h5'
    }
  },
  watch: {
    content (val) {
      if (val.length === 0) {
        this.canSend = false
      } else if (val.length !== 0 && this.sending) {
        this.canSend = false
      } else {
        this.canSend = true
      }
    }
  },
  methods: {
    chooseId (isHideName) {
      this.isHideName = isHideName
      this.isClicked = !this.isClicked
    },
    close () {
      this.$emit('close')
    },
    send () {
      if (this.sending) {
        return
      }
      console.log(this.commentParams)
      this.content = this.content.replace(/&/g, '%26')
      if (this.content.length > 500) {
        this.$toastMessage({ icon: '&#xe7a3;', message1: '评论不能超过500个字符' })
        return
      }
      if (!this.content) {
        this.$toastMessage({ icon: '&#xe7a3;', message1: '评论不能为空' })
        return
      }
      this.sending = true
      const identification = this.$route.query.identification
      dataRanger.send('user_interaction', {
        operation_type: this.commentParams.targetType === '1' ? '评论' : '评论回复',
        content_id: this.commentParams.articleId,
        author_id: sessionStorage.getItem('username')
      })
      this.$store.dispatch('contentCreateComment', {
        isThirdPartPlat: false,
        articleId: this.commentParams.targetId,
        content: this.content,
        isHideName: this.myName === 'nickName',
        targetType: this.commentParams.targetType,
        ssoToken: identification === 'admin' && this.$route.query.token,
        identification: identification,
        appKey: this.$route.query.appKey
      })
        .then(res => {
          console.log(res.data.code)
          if (res.data.code === 0) {
            this.sending = false
            if (this.commentType === 2) {
              this.$toastMessage({ icon: '&#xe66f;', message1: this.$t('lang.contentCommentAuditing'), times: 2000 })
            } else {
              if (res.data.msg === '评论成功!') {
                this.$toastMessage({ icon: '&#xe66f;', message1: this.$t('lang.contentCommentSuccess'), times: 2000 })
              } else {
                this.$toastMessage({ icon: '&#xe66f;', message1: res.data.msg, times: 2000 })
              }
              this.$emit('success')
            }
            // 先审后评，这个不需要了
            // this.$store.dispatch('addCommentNum')
            setTimeout(() => {
              this.content = ''
            }, 900)
            this.$emit('update:pageNum', 1)
          } else {
            this.$toastMessage({ icon: '&#xe7a3;', message1: res.data.msg })
          }
          this.$emit('close', res.data)
        })
        .catch(() => {
          this.sending = false
        })
    },
    scrollTo00 () {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 300)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.textarea.focus()
    })
  },
  activated () {
    this.targetType = this.$route.query.targetType || '1'
  }
}
</script>

<style scoped>
  .write-comment {
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    height: 15.3125rem;
    overflow: hidden;
  }
  header {
    position: relative;
    padding: .532rem 1rem;
    background-color: #fafafa;
    border-top-width: 0;
    border-right-width: 0;
    border-bottom-width: .0625rem;
    border-left-width: 0;
    border-color: #eee;
    border-style: solid;
    height: 3.0625rem;
  }
  header .center-wrapper {
    width: 100%;
    height: 1.9375rem;
    padding: 0 3.5rem 0 0;
    box-sizing: border-box;
    display: flex;
  }
  header .center-wrapper>div {
    display: flex;
    align-items: center;
    /* padding-left: 1.3rem; */
  }
  header .center-wrapper>div:nth-child(1) {
    margin-right: 1rem;
  }
  header .right-wrapper {
    width: 6.0625rem;
    height: 2rem;
    position: absolute;
    right: .4rem;
    top: .5rem;
    padding: .3rem 0 0 2.4375rem;
  }
  header .right-wrapper a {
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
    text-decoration: none;
  }
  main>div {
    overflow-y: hidden;
    padding: .6rem;
    height: 12.25rem;
    background-color: #fff;
  }
  main>div>textarea{
    font-family: sans-serif;
    margin-top: .65625rem;
    color: #222222;
    background-color: transparent;
    outline: 0;
    border: none;
    font-size: 1rem;
    resize: none;
    width: 100%;
    box-sizing: border-box;
  }
  .relative {
    position: relative;
  }
  .absolute {
    position: absolute;
  }
  .choose-id-box {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,.5);
  }
  .choose-id-box>ul {
    display: flex;
    justify-content: space-around;
    width: 100%;
    background-color: #fff;
  }
  .choose-id-box>ul>li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 1rem;
  }
  .choose-id-box>ul>li>img {
    width: 2rem;
    height: 2rem;
  }
  .choose-id-box>ul>li>a {
    font-size: .875rem;
    color:#333;
  }
  label.radio {
    display: inline-block;
    width: 1.1875rem;
    height: 1.1875rem;
    border: .0625rem solid #bfbfbf;
    border-radius: 50%;
    position: relative;
  }
  label .mark {
    position: absolute;
    content: '';
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    left: -.125rem;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: url('../assets/images/checked.png') no-repeat;
    background-size: cover;
  }
  label input[type=radio] {
    width: 1.1875rem;
    height: 1.1875rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    opacity: 0;
  }
  /*label>.on-checked{*/
  /*  width: 1.1875rem;*/
  /*  height: 1.1875rem;*/
  /*  display: inline-block;*/
  /*  border: .0625rem solid #bfbfbf;*/
  /*  border-radius: 50%;*/
  /*  margin: auto;*/
  /*}*/
  label input[type=radio]:checked+.mark {
    display: inline;
    z-index: 100;
  }
  label input[type=radio]:not(:checked)+.mark {
    display: none;
  }
  label+span {
    margin-left: .5rem;
    font-size: 1rem;
    color: #414141;
  }
  .blue {
    color: #148EF5;
  }
  .gray {
    color: #ABABAB;
  }
</style>
